export enum LayoutEventBus {
  inputOnFocus = 'inputOnFocus', //input获取焦点
  inputOnBlur = 'inputOnBlur', //input使焦点
  toolsOnOpen = 'toolsOnOpen', //拓展面板打开
  toolsOnClose = 'toolsOnClose', //拓展面板关闭
  emojiOnOpen = 'emojiOnOpen', //表情面板打开
  emojiOnClose = 'emojiOnClose', //表情面板关闭
  toolPanelClick = 'toolPanelClick', //工具栏点击
}
